module.exports = __webpack_public_path__ + "img/Global_Compact_HumanRights.4786d84b.svg";